export class EmissionScheduler {
    mode;
    delay;
    duration;
    cycleDuration;
    loop;
    /** Fractional particles carried between frames in rate mode. */
    rateAccumulator = 0;
    constructor(mode, delay, duration, cycleDuration, loop) {
        this.mode = mode;
        this.delay = delay;
        this.duration = Math.max(duration, 1e-6);
        this.cycleDuration = Math.max(cycleDuration, 1e-6);
        this.loop = loop;
    }
    reset() {
        this.rateAccumulator = 0;
    }
    /** Emit spawns scheduled in the half-open interval [t0, t1). */
    advance(t0, t1, spawn) {
        if (t1 <= t0)
            return;
        const firstCycle = this.loop ? Math.floor(t0 / this.cycleDuration) : 0;
        const lastCycle = this.loop ? Math.floor(t1 / this.cycleDuration) : 0;
        for (let cycle = firstCycle; cycle <= lastCycle; cycle++) {
            const windowStart = cycle * this.cycleDuration + this.delay;
            if (this.mode.type === 'burst') {
                const cycles = Math.max(1, this.mode.cycles ?? 1);
                const interval = this.mode.interval ?? 0;
                for (let k = 0; k < cycles; k++) {
                    const fireTime = windowStart + k * interval;
                    if (fireTime >= t0 && fireTime < t1) {
                        const norm = cycles > 1 ? k / (cycles - 1) : 0;
                        for (let n = 0; n < this.mode.count; n++)
                            spawn(fireTime, norm);
                    }
                }
            }
            else {
                const rate = this.mode.perSecond;
                if (rate <= 0)
                    continue;
                const windowEnd = windowStart + this.duration;
                const from = Math.max(t0, windowStart);
                const to = Math.min(t1, windowEnd);
                if (to <= from)
                    continue;
                // The j-th spawn happens when the accumulator crosses integer j.
                const accBefore = this.rateAccumulator;
                const acc = accBefore + (to - from) * rate;
                const n = Math.floor(acc);
                for (let j = 1; j <= n; j++) {
                    const spawnTime = from + (j - accBefore) / rate;
                    const norm = Math.min(Math.max((spawnTime - windowStart) / this.duration, 0), 1);
                    spawn(spawnTime, norm);
                }
                this.rateAccumulator = acc - n;
            }
        }
    }
}
